// @flow

import debounce from 'debounce';
import * as React from 'react';
import connect from 'react-redux/lib/connect/connect';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import onlyUpdateForKeys from 'recompose/onlyUpdateForKeys';
import setDisplayName from 'recompose/setDisplayName';
import { selectFontSize } from '../store/selectors';

type FontSizeAdjusterProps = {
  children: React.Node,
};

const cutOffWidth = 400;

const FontSizeAdjuster = compose(
  setDisplayName('ConnectFontSize(FontSizeAdjuster)'),
  connect(state => ({ fontSize: selectFontSize(state) })),

  setDisplayName('OnlyUpdateForKeys(FontSizeAdjuster)'),
  onlyUpdateForKeys(['children', 'fontSize']),

  setDisplayName('UpdateHtmlFontSize(FontSizeAdjuster)'),
  lifecycle({
    smallScreenMediaQuery: (window.matchMedia && window.matchMedia(`(max-width: ${cutOffWidth}px)`)) || null,
    componentDidMount(): void {
      this.setFontSize = this.setFontSize.bind(this);
      this.debouncedResizeHandler = debounce(this.setFontSize, 100);
      window.addEventListener('resize', this.debouncedResizeHandler);
      this.setFontSize();
    },
    componentDidUpdate(): void {
      this.setFontSize(this.smallScreenMediaQuery);
    },
    componentWillUnmount(): void {
      window.removeEventListener('resize', this.debouncedResizeHandle);
    },
    setFontSize(): void {
      const htmlElement: ?HTMLElement = document.querySelector('html');

      if (!htmlElement) {
        return;
      }

      const { fontSize } = this.props;

      let adjustment: number = fontSize * 100;

      if (window.innerWidth <= cutOffWidth) {
        adjustment = ((fontSize - 1) / 2) * window.innerWidth + (2 - fontSize) * 100;
      }

      htmlElement.style.fontSize = `${adjustment}%`;
      htmlElement.dataset.fontSize = String(fontSize);
    },
  }),
)(
  setDisplayName('FontSizeAdjuster')(
    ({ children }: FontSizeAdjusterProps) => (children ? React.Children.only(children) : null),
  ),
);

export default FontSizeAdjuster;



// WEBPACK FOOTER //
// ./src/modules/accessibility/components/FontSizeAdjuster.js